export default "/_next/static/images/Wire-2-892ba49416658af402a78b9aa9380709.svg";